import type { Event } from '@/data/types';

interface RSSItem {
  title: string;
  description: string;
  link: string;
  pubDate: string;
  guid: string;
}

export function generateRSSFeed(events: Event[], siteTitle: string, siteUrl: string): string {
  const items = events
    .filter(event => new Date(event.date) >= new Date())
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
    .slice(0, 10) // Limit to 10 most recent upcoming events
    .map(event => {
      const titles = Array.isArray(event.title) ? event.title.join(', ') : event.title;
      const times = Array.isArray(event.time) ? event.time.join(', ') : event.time;

      const item: RSSItem = {
        title: titles,
        description: `${event.description || ''} Time: ${times}. Date: ${event.date}`.trim(),
        link: `${siteUrl}/events`,
        pubDate: new Date(event.date).toUTCString(),
        guid: `${siteUrl}/events#${event.date.replace(/[^a-zA-Z0-9]/g, '-')}-${titles.replace(/[^a-zA-Z0-9]/g, '-')}`
      };

      return item;
    });

  const rssXml = `<?xml version="1.0" encoding="UTF-8"?>
<rss version="2.0">
  <channel>
    <title>${siteTitle} - Events</title>
    <description>Upcoming events and activities at ${siteTitle}</description>
    <link>${siteUrl}/events</link>
    <lastBuildDate>${new Date().toUTCString()}</lastBuildDate>
    <language>en-US</language>
    <generator>Wayland Rod &amp; Gun Club Website</generator>

    ${items.map(item => `<item>
      <title><![CDATA[${item.title}]]></title>
      <description><![CDATA[${item.description}]]></description>
      <link>${item.link}</link>
      <pubDate>${item.pubDate}</pubDate>
      <guid isPermaLink="false">${item.guid}</guid>
    </item>`).join('\n    ')}
  </channel>
</rss>`;

  return rssXml;
}

export function downloadRSSFeed(events: Event[], siteTitle: string, siteUrl: string) {
  const rssContent = generateRSSFeed(events, siteTitle, siteUrl);
  const blob = new Blob([rssContent], { type: 'application/rss+xml' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'events-rss-feed.xml';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}